import {__, compose, equals, pathOr} from 'ramda';

import {ApplicationStoreType} from 'reducers';
import {SelectorType} from 'constants/flow/flowTypes';

/**
 * Returns is Configure Page or not
 * @param {ApplicationStoreType} store - Current store
 * @returns {boolean} - Stored cartKey
 */
export const isConfigurePage = (store: ApplicationStoreType): boolean =>
    store.pageApp.page === 'productEdit';

/**
 * Returns is category page or not
 * @param {ApplicationStoreType} store - Current store
 * @returns {boolean} - is category page flag
 */
export const isCategoryPage = (store: ApplicationStoreType): boolean =>
    store.routerInfo.page === 'category';

/**
 * Determines is product page active
 * @type {SelectorType<boolean>}
 * @returns {boolean} flag
 */
export const isProductPage: SelectorType<boolean> = compose(
    equals(__, 'product'),
    pathOr('', ['routerInfo', 'page']),
);
